import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { PersonalInfoPage } from '@egw/features-settings'

export const SettingsPersonalInfoPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.settings.title')} />
      <PersonalInfoPage />
    </Layout>
  )
}
